import configManager from "../singleton/ConfigManager";
import {
  IDLE_DETECTION_RESUMED_EVENT,
  IDLE_DETECTION_SUSPENDED_EVENT,
  isIdleDetectionSuspended
} from "../utils/idle-detection-suspender";
import { LOCAL_MIC_AUDIO_ACTIVITY_EVENT } from "../utils/local-mic-audio-activity";
import { paths } from "./userinput/paths";
const qs = new URLSearchParams(location.search);
const IDLE_ENABLED = configManager.config.idle.enabled;
const DEFAULT_IDLE_TIMEOUT_SECONDS = 30 * 60;
const IDLE_TIMEOUT_MS = IDLE_ENABLED
  ? (parseInt(qs.get("idle_timeout"), 10) || DEFAULT_IDLE_TIMEOUT_SECONDS) * 1000
  : null;
const INPUT_CHECK_INTERVAL_MS = 1000;
const WINDOW_ACTIVITY_EVENTS = ["click", "pointerdown", "touchstart", "keyup"];

const CHARACTER_ACCELERATION_PATH = paths.actions.characterAcceleration;
const BASIC_ACTIVITY_PATHS = [
  paths.actions.startGazeTeleport,
  paths.actions.rightHand.startTeleport,
  paths.actions.leftHand.startTeleport,
  paths.actions.snapRotateRight,
  paths.actions.snapRotateLeft,
  paths.actions.cursor.right.grab,
  paths.actions.cursor.left.grab,
  paths.actions.rightHand.grab,
  paths.actions.leftHand.grab,
  paths.actions.angularVelocity
];

AFRAME.registerSystem("idle-detector", {
  init() {
    if (!IDLE_ENABLED) return;
    this.resetTimeout = this.resetTimeout.bind(this);
    this.onIdleTimeout = this.onIdleTimeout.bind(this);
    this.onIdleDetectionSuspended = this.onIdleDetectionSuspended.bind(this);
    this.onIdleDetectionResumed = this.onIdleDetectionResumed.bind(this);
    this.idleTimeout = null;
    this.lastInputCheck = 0;

    for (const event of WINDOW_ACTIVITY_EVENTS) {
      window.addEventListener(event, this.resetTimeout);
    }
    window.addEventListener("resetIdleTimeout", this.resetTimeout);
    window.addEventListener(LOCAL_MIC_AUDIO_ACTIVITY_EVENT, this.resetTimeout);
    window.addEventListener(IDLE_DETECTION_SUSPENDED_EVENT, this.onIdleDetectionSuspended);
    window.addEventListener(IDLE_DETECTION_RESUMED_EVENT, this.onIdleDetectionResumed);

    this.resetTimeout();
  },
  resetTimeout() {
    if (!IDLE_ENABLED || isIdleDetectionSuspended()) return;
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(this.onIdleTimeout, IDLE_TIMEOUT_MS);
    window.dispatchEvent(new CustomEvent("activity_detected"));
  },
  onIdleTimeout() {
    if (!IDLE_ENABLED || isIdleDetectionSuspended()) return;
    window.dispatchEvent(new CustomEvent("idle_detected"));
  },
  onIdleDetectionSuspended() {
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    this.idleTimeout = null;
  },
  onIdleDetectionResumed() {
    this.resetTimeout();
  },
  tick(time) {
    if (!IDLE_ENABLED) return;
    if (time - this.lastInputCheck < INPUT_CHECK_INTERVAL_MS) return;

    const userinput = this.el.systems.userinput;

    let basicActivity = false;
    for (const activityPath of BASIC_ACTIVITY_PATHS) {
      basicActivity = basicActivity || !!userinput.get(activityPath);
    }

    const characterAcceleration = userinput.get(CHARACTER_ACCELERATION_PATH);

    const active =
      basicActivity ||
      !!(characterAcceleration && characterAcceleration[0]) ||
      !!(characterAcceleration && characterAcceleration[1]);

    if (active) {
      this.resetTimeout();
    }
  },
  remove() {
    if (!IDLE_ENABLED) return;
    for (const event of WINDOW_ACTIVITY_EVENTS) {
      window.removeEventListener(event, this.resetTimeout);
    }
    window.removeEventListener("resetIdleTimeout", this.resetTimeout);
    window.removeEventListener(LOCAL_MIC_AUDIO_ACTIVITY_EVENT, this.resetTimeout);
    window.removeEventListener(IDLE_DETECTION_SUSPENDED_EVENT, this.onIdleDetectionSuspended);
    window.removeEventListener(IDLE_DETECTION_RESUMED_EVENT, this.onIdleDetectionResumed);
  }
});
